import { LEGACY_DATA, LEGACY_CARDS } from "@/data/legacy_data.js";

export default {
  name: "ChooseYourLegacySection",

  data() {
    return ({
      legacy_data: LEGACY_DATA,
      legacy_cards: LEGACY_CARDS,
    });
  },
};
